"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M15.732 6a2 2 0 0 0-2.972-2.57A2.5 2.5 0 1 0 8.5 6h-4A1.5 1.5 0 0 0 3 7.5v2a1.5 1.5 0 0 0 1 1.415V17.5A2.5 2.5 0 0 0 6.5 20h11a2.5 2.5 0 0 0 2.5-2.5v-6.585A1.5 1.5 0 0 0 21 9.5v-2A1.5 1.5 0 0 0 19.5 6zM9 4.5a1.5 1.5 0 1 1 3 0V6h-1.5A1.5 1.5 0 0 1 9 4.5M16 7v3H8V7zm-2-1h-1V5a1 1 0 1 1 1 1M4 7.5a.5.5 0 0 1 .5-.5H7v3H4.5a.5.5 0 0 1-.5-.5zM17 10V7h2.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zM5 17.5V11h5v8H6.5A1.5 1.5 0 0 1 5 17.5m6 1.5v-8h2v8zm3 0v-8h5v6.5a1.5 1.5 0 0 1-1.5 1.5z"
}), 'Gift');
//# sourceMappingURL=index.js.map